<div class="imod-data-table equipment-info-table" #equipmentInfoContainer>
  <p-table [columns]="columns" [value]="dataTable"
    [scrollHeight]="chassisInventoryTable ? '675.500px' : null" [scrollable]="chassisInventoryTable ? true : false"
    responsiveLayout="stack">
    <ng-template #header *ngIf="hasHeader">
      <tr>
        <th *ngFor="let col of columns" [ngStyle]="{
            width: col?.style?.width,
          }">
          <div [ngStyle]="{ display: 'flex', alignItems: 'center' }">
            <ng-container *ngIf="!isEtaHeader(col?.header); else etaHeaderTemplate">
              {{ col.header }}
            </ng-container>
            <ng-template #etaHeaderTemplate>
              <span *ngIf="getEtaHeaderPrefix(col?.header)">{{ getEtaHeaderPrefix(col?.header) }}</span>
              <span *ngIf="getEtaHeaderPrefix(col?.header)">&nbsp;</span>
              <span class="ioh-realtime-eta-badge">ETA</span>
            </ng-template>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [style.cursor]="rowClickable ? 'pointer' : 'default'" (click)="handleRowClick(rowData)">
        <ng-container *ngFor="let col of columns">
          <td *ngIf="!col.hide && col.field !== 'performance'" [ngStyle]="{ width: col?.width, color: col.color }">
            <ng-container *ngIf="col.field === 'vehicleType' && !col?.field?.includes('Time')">
              <span [ngStyle]="{ 'font-weight': 'bold' }">{{
                rowData[col?.field]?.toUpperCase()
                }}</span>
              <span>({{ rowData['total'] }})</span>
            </ng-container>
            <ng-container *ngIf="col.field === 'trainId'">
              <div class="train-id-with-status">
                <span>{{ rowData[col?.field] }}</span>
                <ng-container *ngIf="hasStatus(rowData['status'])">
                  <ng-container *ngIf="getTrainStatusConfig(rowData['status']) as statusConfig">
                    <span class="status-chip" [ngStyle]="statusConfig.style">
                      <i *ngIf="statusConfig.iconClass" [class]="statusConfig.iconClass"></i>
                      {{ rowData['status'] }}
                    </span>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="col.field !== 'vehicleType' && col.field !== 'trainId' && !col?.field?.includes('Time')">
              {{ rowData[col?.field] }}
            </ng-container>
            <ng-container *ngIf="col?.field?.includes('Time')">
              <span
                [ngClass]="{
                  'ioh-realtime-eta-badge': shouldItalicizeAdjustedTime(col?.header, rowData['status'])
                }" style="color:#fff"
              >
                {{ rowData[col?.field]
                      ? utc(rowData[col?.field])
                          .local()
                          .format('MM/DD/YYYY HH:mm')
                      : '' }}
              </span>
            </ng-container>
          </td>
          <td *ngIf="col.field === 'performance'">
            <span class="performance-chip" [ngStyle]="getPerformanceColor(rowData[col?.field])">
              {{ timeToTotalMinutes(rowData['perfTimeDiff'], rowData[col?.field]) }}
            </span>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="ioh-no-records-found">
        <td [attr.colspan]="columns.length" class="text-center">
          No Records Found
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>